module.exports = __webpack_public_path__ + "static/media/Welcome to ITB 2.0.b2588bd2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/Welcome to ITB 2.0.mp4
// module id = 2568
// module chunks = 0